module.exports = __webpack_public_path__ + "img/5-6.233902f4.png";